import React, { Component } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import FilledInput from "@material-ui/core/FilledInput";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Grid from "@material-ui/core/Grid";
import liffHelper from "../../utils/liffHelper";
import { Redirect } from "react-router-dom";
import Noredi from "./ProfileNoredi";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
// import Grid from '@material-ui/core/Grid';
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
// import { makeStyles } from '@material-ui/core/styles';
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing(3, 2)
  },
  margin: {
    margin: theme.spacing(1)
  },
  withoutLabel: {
    marginTop: theme.spacing(3)
  },
  textField: {
    width: 200
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: this.props.location.state.id,
      password: "",
      weight: "",
      weightRange: "",
      showPassword: false
    };
  }
  async componentDidMount() {
    // alert(this.props.location.state.id)
    // const  profile = await liffHelper.getProfile()
    // this.setState({ profile });
    //   const  nna = await liffHelper.checkmongo(this.state.profile.userId)
    //   // alert(nna)
    //   if(nna != undefined){
    //   this.setState({
    //     mongo: {
    //       ...this.state.mongo,
    //       Ck_Name: nna.Ck_Name,
    //     }
    //   })
    //   }else{
    //     this.setState({
    //       redi: {
    //         ...this.state.redi,
    //         redirect: true,
    //       }
    //     })
    //   }
  }
  renderRedirect = () => {
    if (
      this.state.password == "Admin" ||
      this.state.password == "rplc" || 
      this.state.password == "motor" || 
      this.state.password == "aicp"
    ) {
      // if (this.state.password == "Admin") {
        return (
          <Redirect
            to={{
              pathname: "/regisadmin",
              state: { password: this.state.password }
            }}
          />
        );
      // }
    }

    // if (this.state.password == "Admin") {
    //   return <Redirect
    //     to={{
    //       pathname: '/regisadmin',
    //       state: {password : this.state.password }
    //     }}
    //   />
    // }
  };

  handleChange(event) {
    this.setState({ password: event.target.value });
  }
  //    handleChange = prop => event => {
  //     setValues({ ...values, [prop]: event.target.value });
  //   };

  //    handleClickShowPassword = () => {
  //     setValues({ ...values, showPassword: !values.showPassword });
  //   };

  //    handleMouseDownPassword = event => {
  //     event.preventDefault();
  //   };

  render() {
    const classes = this.props;

    return (
      // <div className={classes.root}>
      // <div>
      //   <Noredi />

      <div className={classes.root}>
        <Noredi />
        {this.renderRedirect()}
        <Paper className={classes.paper} style={{ marginTop: 10, padding: 30 }}>
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={this.state.amount}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              {/* {this.state.amount} */}
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={this.handleChange.bind(this)}
              />
            </form>
          </div>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/components/LoginAdmin.js